import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { getCommunityThreadConnectionQuery } from 'shared/graphql/queries/community/getCommunityThreadConnection';

export const deleteThreadMutation = gql`
  mutation deleteThread($threadId: ID!) {
    deleteThread(threadId: $threadId)
  }
`;

const deleteThreadOptions = {
  props: ({ ownProps, mutate }) => ({
    ...ownProps,
    deleteThread: (threadId, selectedType) =>
      mutate({
        variables: {
          threadId,
          selectedType,
        },
        update: store => {
          // Read the data from our cache for this query.
          const data = store.readQuery({
            query: getCommunityThreadConnectionQuery,
            variables: {
              id: ownProps.extraProps.thread.community.id,
              postType: selectedType ? selectedType : 'ALL',
            },
          });
          data.community.threadConnection.edges = data.community.threadConnection.edges.filter(
            ({ node }) => node.id !== threadId
          );
          // Write our data back to the cache.
          store.writeQuery({
            query: getCommunityThreadConnectionQuery,
            data,
            variables: {
              id: ownProps.extraProps.thread.community.id,
              postType: selectedType ? selectedType : 'ALL',
            },
          });
        },
      }),
  }),
};

export default graphql(deleteThreadMutation, deleteThreadOptions);
